import { mountCartLines } from '../cart/cartLines.ts';

const linesEl = document.getElementById('panier-lines');
const emptyEl = document.getElementById('panier-empty');
const contentEl = document.getElementById('panier-content');
const totalEl = document.getElementById('panier-total');

if (linesEl && emptyEl && contentEl && totalEl) {
  void mountCartLines({ linesEl, emptyEl, contentEl, totalEl });
}
